import React from 'react';
import { colors } from '../constants';

const NoteItem = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox="0 0 20 20"
  >
    <path
      fill={props.color}
      d="M18.7328797,11.532333 C18.7328797,12.6330569 17.8281938,13.520345 16.7198927,13.520345 L2.32391239,13.520345 C1.21561133,13.520345 0.310925376,12.6330569 0.310925376,11.532333 L0.310925376,1.98801199 C0.310925376,0.886657005 1.21538423,0 2.32391239,0 L16.7198927,0 C17.8284209,0 18.7328797,0.886657005 18.7328797,1.98801199 L18.7328797,11.532333 Z M17.3043083,11.532333 L17.3043083,1.98801199 C17.3043083,1.68206129 17.045729,1.42857143 16.7198927,1.42857143 L2.32391239,1.42857143 C1.99807611,1.42857143 1.7394968,1.68206129 1.7394968,1.98801199 L1.7394968,11.532333 C1.7394968,11.837803 1.99844722,12.0917736 2.32391239,12.0917736 L16.7198927,12.0917736 C17.0453579,12.0917736 17.3043083,11.837803 17.3043083,11.532333 Z M11.0158402,7.80988251 C11.4103293,7.80988251 11.7301259,8.12967912 11.7301259,8.52416823 C11.7301259,8.91865733 11.4103293,9.23845394 11.0158402,9.23845394 L10.7263145,9.23845394 C10.3318254,9.23845394 10.0120288,8.91865733 10.0120288,8.52416823 C10.0120288,8.12967912 10.3318254,7.80988251 10.7263145,7.80988251 L11.0158402,7.80988251 Z M4.69360911,5.42893013 C4.29912,5.42893013 3.97932339,5.10913352 3.97932339,4.71464442 C3.97932339,4.32015531 4.29912,4.0003587 4.69360911,4.0003587 L14.2797152,4.0003587 C14.6742043,4.0003587 14.9940009,4.32015531 14.9940009,4.71464442 C14.9940009,5.10913352 14.6742043,5.42893013 14.2797152,5.42893013 L4.69360911,5.42893013 Z M4.69360911,9.23845394 C4.29912,9.23845394 3.97932339,8.91865733 3.97932339,8.52416823 C3.97932339,8.12967912 4.29912,7.80988251 4.69360911,7.80988251 L8.48408989,7.80988251 C8.878579,7.80988251 9.19837561,8.12967912 9.19837561,8.52416823 C9.19837561,8.91865733 8.878579,9.23845394 8.48408989,9.23845394 L4.69360911,9.23845394 Z"
      transform="translate(.5 3)"
    />
  </svg>
);

NoteItem.displayName = 'NoteItem';

NoteItem.defaultProps = {
  color: colors.mediumGrey,
};

export default NoteItem;
